import React from "react";
import { MemoryRouter, BrowserRouter, Route } from "react-router-dom";

import ModuleGenerator from "./containers/moduleGenerator";
import ButtonGenerator from "./containers/moduleGenerator/buttonGenerator";

import DoubleHome from "./containers/doubleHome/index";
import Pactometro from "./containers/pactometro/index";
import Bars from "./containers/bars";
import SumaBloques from "./containers/sumaBloques";
import RankingPactometro from "./containers/rankingPactometro";
// const Home = React.lazy(() => import("./containers/home"));

const Router =
  window.parent !== window ||
  window.location.hostname === "localhost" ||
  window.location.href.indexOf("tvmodules") !== -1 ||
  window.location.href.indexOf("generador") !== -1
    ? BrowserRouter
    : MemoryRouter;

const basename = process.env.PUBLIC_URL || "/";

const Main = ({ entry, host, setHost }) => (
  <div className="_main elecciones-2019">
    <Router basename={basename} initialEntries={[entry]}>
      <div>
        {/* Urls de prueba: Comunidad -> http://localhost:3000/elections/C108/0/2019/GENERAL/1/arc-bars/R12-R16/resultados.html 
                           Localidad -> http://localhost:3000/elections/C108/0/2019/GENERAL/1/arc/R12/32/32016/resultados.html
                           Completo --> http://localhost:3000/elections/C108/0/2019/GENERAL/1/arc/R12-R16/15-48/15019-48080/resultados.html 
        */}
        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/:chartTypes/:communities?/:provinces?/:towns?/resultados.html"
          component={props => (
            <React.Suspense fallback="LOADING">
              {" "}
              <DoubleHome {...props}></DoubleHome>
            </React.Suspense>
          )}
        />

        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/:community/sumaBloques.html"
          component={SumaBloques}
        />

        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/:community/pactometro.html"
          component={Pactometro}
        />

        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/:community/bars.html"
          component={Bars}
        />

        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/:community/rankingPactometro.html"
          component={RankingPactometro}
        />

        <Route
          exact
          path="/test.html"
          component={() => (
            <ButtonGenerator
              navegable={1}
              type={""}
              electionType={"REGIONAL"}
              year={2020}
              electionNumber={1}
              location={{ typePlace: "REGION", ineId: "R12" }}
            ></ButtonGenerator>
          )}
        />

        <Route
          exact
          path="/generador.html"
          component={() => (
            <ModuleGenerator host={host} setHost={setHost}></ModuleGenerator>
          )}
        />
      </div>
    </Router>
  </div>
);

export default Main;
